export enum ExternalMessageType {
  Authenticate = 'authenticate',
  SignOut = 'signOut',
}
